import React from 'react'
import styled from 'styled-components'
import imgSrc from '@assets/undraw/undraw_complete-form_aarh.svg'
import { BetaPill, Button } from '@root/components'
import { motion } from 'framer-motion'
import { useScreen } from '@root/utils'
import { useTranslation } from 'react-i18next'

interface Props {
  onCreateRule: () => void
}

const AccountingRulesLander: React.FC<Props> = ({ onCreateRule }) => {
  const { isMobile } = useScreen()
  const [t] = useTranslation()

  return (
    <StyledLander>
      <StyledImg src={imgSrc} alt="Rules Settings" isMobile={isMobile} />

      <StyledTitle>
        <h2>{t('settings.automation.accountingRulesLander.header')}</h2>
        <BetaPill label={t('general.beta.label')} tooltip={t('general.beta.tooltip')} />
      </StyledTitle>

      <p>{t('settings.automation.accountingRulesLander.description1')}</p>
      <p>{t('settings.automation.accountingRulesLander.description2')}</p>
      <p>{t('settings.automation.accountingRulesLander.description3')}</p>

      <Button intent="primary" type="button" onClick={onCreateRule}>
        {t('settings.automation.accountingRulesLander.createNewRule')}
      </Button>
    </StyledLander>
  )
}

export default AccountingRulesLander

const StyledLander = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: ${({ theme }) => theme.spacing.lg}rem;

  p {
    font-size: ${({ theme }) => theme.fontSize.md}rem;
    max-width: 400px;
    color: ${({ theme }) => theme.colors.metalGray};
    margin-bottom: ${({ theme }) => theme.spacing.md}rem;
  }

  button {
    margin-top: 1rem;
  }
`

const StyledImg = styled(motion.img).attrs({
  src: imgSrc,
  initial: { opacity: 0, scale: 0.8, y: 50, rotate: 15 },
  animate: { opacity: 1, scale: 1, y: 0, rotate: 0 },
  transition: { delay: 0.1 }
})<{ isMobile: boolean }>`
  max-width: 500px;
  width: 100%;
  padding: ${({ isMobile }) => (isMobile ? '1rem' : '3rem')};
  padding-top: 1rem;
`

const StyledTitle = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing.xs}rem;
  margin-bottom: ${({ theme }) => theme.spacing.md}rem;

  h2 {
    font-size: ${({ theme }) => theme.fontSize.lg}rem;
    margin: 0;
  }
`
